import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-bim-maintenace-detail',
  templateUrl: './bim-maintenace-detail.component.html',
  styleUrls: ['./bim-maintenace-detail.component.less']
})
export class BimMaintenaceDetailComponent implements OnInit {

  constructor() { }

  @Input() maintenanceList: any;

  ngOnInit(): void {
    const myBimDiv = document.getElementById('bim-maintenance-table') as HTMLDivElement;
    myBimDiv.innerHTML =  this.showProperties(this.maintenanceList);
  }

  showProperties( data: any): string {
    let html = null;
    if (html == null) {
      // tslint:disable-next-line: max-line-length
      html = '<div style ="height:580px;width:480px;overflow-y:auto;" >';
      html += '<table border="1">';
    }
    const jobList = data.维修列表;
    for (const item of jobList){
      html += '<tr><th style="height:30px;width:150px">工单编号</th><th style="height:30px;width:330px">' + this.isEmpty(item.jno) + '</th></tr>';
      html += '<tr><td>' + '报修人' + '</td><td>' + this.isEmpty(item.callerName) + '</td></tr>';
      html += '<tr><td>' + '报修人电话' + '</td><td>' + this.isEmpty(item.callerPhone) + '</td></tr>';
      html += '<tr><td>' + '报修时间' + '</td><td>' + this.isEmpty(item.callTime) + '</td></tr>';
      html += '<tr><td>' + '维修人' + '</td><td>' + this.isEmpty(item.dispatcherName) + '</td></tr>';
      html += '<tr><td>' + '预估完成时间' + '</td><td>' + this.isEmpty(item.estimatedCompletedTime) + '</td></tr>';
      html += '<tr><td>' + '设备编号' + '</td><td>' + this.isEmpty(item.epNo) + '</td></tr>';
      html += '<tr><td>' + '工单类型' + '</td><td>' + this.isEmpty(item.jtName) + '</td></tr>';
      html += '<tr><td>' + '工单级别' + '</td><td>' + this.isEmpty(item.jlName) + '</td></tr>';
      html += '<tr><td>' + '工单位置' + '</td><td>' + this.isEmpty(item.location) + '</td></tr>';
      html += '<tr><td>' + '工单状态' + '</td><td>' + this.isEmpty(item.statusName) + '</td></tr>';
      html += '<tr><td>' + '完成时间' + '</td><td>' + this.isEmpty(item.completedTime) + '</td></tr>';
      html += '<tr><td>' + '完成记录' + '</td><td>' + this.isEmpty(item.completedRecord) + '</td></tr>';
      html += '<tr><td>' + '备注' + '</td><td>' + this.isEmpty(item.mark) + '</td></tr>';
    }
    html += '</table>';
    html += '</div>';
    return html;
  }

  isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return '';
    } else {
      return obj;
    }
  }

}
